import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Col, Container, Row, Form, Card, Button } from 'react-bootstrap';
import { Controller, useForm } from "react-hook-form";
import axios from "axios";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Countdown from 'react-countdown';
import Loader from "../../Loader";
import CompanyNotFound from "./Modal/CompanyNotFount";

const Receiverdetails = (props) => {
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const [selectedOption, setSelectedOption] = useState(null);
  const {
    register,
    control,
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { errors }
  } = useForm({
    defaultValues: {
      recipientName: null,
      currency: null,
      payment: null,
      invoice: null,
      bankDetails: null,
      paymentType: null,
      companyName: null,
    }
  });
  const { quotationId } = useParams();
  const token = useSelector((state) => state.token);
  const user = useSelector((state) => state.user);
  const [companyInfo, setCompanyInfo] = useState(false);
  const [quotation, setQuotation] = useState({});
  const [currencyData, setCurrencyData] = useState({});

  const GetBankDetails = (currency) => {
    axios({
      method: "GET",
      url: `${process.env.REACT_APP_BASE_URL}/setting/currency/${currency}`,
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      }
    }).then(res => {
      setCurrencyData(res.data.setting);
    }).catch(() => {});
  }

  const GetQuotationData = () => {
    setLoader(true);
    axios({
      method: "GET",
      url: `${process.env.REACT_APP_BASE_URL}/quotation/${quotationId}`,
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      }
    }).then(res => {
      setQuotation(res.data.quotation);
      GetBankDetails(res.data.quotation.currency);
      setLoader(false);
    }).catch(err => {
      setLoader(false);
    });
  }

  const handleOrder = (data) => {
    setLoader(true);
    const newData = new FormData();
    newData.append("userId", user._id);
    newData.append("quotationId", quotationId);
    newData.append("receiverName", data.recipientName);
    newData.append("backDetails", data.bankDetails)
    newData.append("proof", data.payment[0]);
    newData.append("invoice", data?.invoice?.[0] || null);
    newData.append("paymentType", data.paymentType);
    newData.append("companyName", data?.companyName || null);
    axios({
      method: "POST",
      url: `${process.env.REACT_APP_BASE_URL}/order`,
      headers: {
        "Content-Type": "multipart/form-data",
        "Authorization": `Bearer ${token}`
      },
      data: newData
    }).then(res => {
      setLoader(false);
      toast(res.data.message, {
        theme: "light",
        position: "top-right",
        type: "success"
      });
      navigate('/userorders');
    }).catch(err => {
      setLoader(false);
      if (err?.response?.data?.errors) {
        toast(err.response.data.errors[0]?.msg, {
          theme: "light",
          position: "top-right",
          type: "error"
        })
      } else {
        toast(err?.response?.data?.message || err.message || "Order submission was unsuccessful.", {
          theme: "light",
          position: "top-right",
          type: "error"
        });
      }
    });
  }

  useEffect(() => {
    GetQuotationData();
  }, [quotationId]);

  useEffect(() => {
    const allowedCompanies = user?.companies?.filter(f => f.status === "Approve");
    if (watch("paymentType") === "Company" && allowedCompanies?.length > 0) {
      setValue("companyName", allowedCompanies[0].name);
    }
  }, [watch("paymentType")]);

  return (
    <>
      <section className='user_main'>
        <Container>
          <Row className="justify-content-center">
            <Col md={12}>
              <Card>
                <Card.Header>
                  <div className="d-flex align-items-center justify-content-between gap-3">
                    <div className="head_title">
                      <h3 className="mb-0">Add Receiver Details</h3>
                    </div>
                  </div>
                </Card.Header>
                <Card.Body>
                  <Card.Text>

                    <Row>
                      <Col xl={3} sm={6} className="mb-4">
                        <div className="info_item">
                          <strong>Your currency :</strong>
                          <p>{quotation?.currency?.toUpperCase()}</p>
                        </div>
                      </Col>
                      <Col xl={3} sm={6} className="mb-4">
                        <div className="info_item">
                          <strong>Recipient currency :</strong>
                          <p>{quotation?.recipientCurrency?.toUpperCase()}</p>
                        </div>
                      </Col>
                      <Col xl={3} sm={6} className="mb-4">
                        <div className="info_item">
                          <strong>Recipient amount :</strong>
                          <p>{parseFloat(quotation?.recipientAmount) > 0.01 ? parseFloat(quotation.recipientAmount).toLocaleString(undefined, { maximumFractionDigits:2, minimumFractionDigits:2 }) : parseFloat(quotation.recipientAmount)}</p>
                        </div>
                      </Col>
                      <Col xl={3} sm={6}>
                        <div className="info_item">
                          <strong>Expire on :</strong>
                          <p>{new Date(quotation.expireDate) > new Date() ?
                            <Countdown
                              autoStart
                              date={new Date(quotation.expireDate)}
                            />
                            : "00:00:00:00"}</p>
                        </div>
                      </Col>
                      {currencyData?.bankDetails?.length > 0 ?
                        <>
                          {currencyData.bankDetails.map(bd => {
                            return (
                              <Col md={6} className="mb-4">
                                <div className="info_item flex-column h-100 justify-content-start align-items-start table-responsive">
                                  <strong>Bank details :</strong>
                                  <pre style={{ whiteSpace: 'pre-wrap' }}>
                                    {`${bd}`}
                                  </pre>
                                </div>
                              </Col>
                            );
                          })}
                        </>
                        : null}


                      <Col md={12}>
                        <div className="info_item flex-wrap">
                          <strong>Payment type :</strong>
                          <div className="d-flex align-items-center flex-wrap gap-3">
                            <Controller
                              control={control}
                              name="paymentType"
                              rules={{
                                required: { message: "Payment type is require", value: true }
                              }}
                              render={({ field }) => {
                                return (
                                  <>
                                    <Form.Check
                                      className="d-flex align-items-center gap-2 mb-0"
                                      type="radio"
                                      label="Personal Payment"
                                      name="paymentType"
                                      value={"Personal"}
                                      checked={watch("paymentType") == "Personal" ? true : false}
                                      id="paymentType1"
                                      onChange={field.onChange} />
                                    <Form.Check
                                      className="d-flex align-items-center gap-2 mb-0"
                                      type="radio"
                                      label="Company Payment"
                                      name="paymentType"
                                      value={"Company"}
                                      checked={watch("paymentType") == "Company" ? true : false}
                                      onChange={(t) => {
                                        if (user?.companies?.length == 0) {
                                          return setCompanyInfo(true);
                                        }
                                        const company = user?.companies?.filter(f => f.status == "Approve");
                                        if (company?.length == 0) {
                                          return setCompanyInfo(true);
                                        }
                                        field.onChange(t.target.value);
                                      }}
                                      id="paymentType2" />
                                  </>
                                );
                              }} />
                          </div>
                        </div>
                        {errors.paymentType ? <p className="errMsg">{errors.paymentType.message}</p> : null}
                        {watch("paymentType") === "Company" ?
                          <>
                          <div className="info_item flex-wrap mt-2">
                            <strong>Companies :</strong>
                            <div className="d-flex align-items-center flex-wrap gap-3">
                              <Controller
                                name="companyName"
                                control={control}
                                rules={{
                                  required: { message: "Company is require", value: true }
                                }}
                                render={({ field }) => {
                                  return (
                                    <>
                                      {user?.companies?.map((p, index) => {
                                        if (p.status === "Approve") {
                                          return (<Form.Check
                                            className="d-flex align-items-center gap-2 mb-0"
                                            type="radio"
                                            label={p.name}
                                            name="companyName"
                                            value={p.name}
                                            onChange={field.onChange}
                                            checked={field.value === p.name}
                                            id={`companyName${index}`} />);
                                        } else {
                                          return null
                                        }
                                      })}
                                    </>
                                  )
                                }} />
                            </div>

                          </div>
                          {errors.companyName ? <p className="errMsg">{errors.companyName.message}</p> : null}
                          </>
                          : null}
                      </Col>
                    </Row>

                    <Form className="row mt-4" onSubmit={handleSubmit(handleOrder)}>
                      <Form.Group as={Col} md="12" className="mb-3" controlId="Amounttosend">
                        <Form.Label>Recipient Name <span>*</span></Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter recipient name"
                          {...register("recipientName", {
                            required: { message: "Recipient name is require", value: true },
                            minLength: { message: "Recipient name not valid", value: 2 }
                          })} />
                        {errors.recipientName ? <p className="errMsg">{errors.recipientName.message}</p> : null}
                      </Form.Group>

                      <Form.Group as={Col} md="12" controlId="formFile" className="mb-3">
                        <Form.Label>Recipient Bank Details <span>*</span></Form.Label>

                        <Form.Control
                          as="textarea"
                          placeholder="Enter bank details here"
                          style={{ height: "250px" }}
                          {...register("bankDetails", {
                            required: { message: "Bank details is require", value: true },
                            minLength: { message: "Bank details is not valid", value: 10 }
                          })}
                        />
                        {errors.bankDetails ? <p className="errMsg">{errors.bankDetails.message}</p> : null}

                      </Form.Group>

                      <Form.Group as={Col} md="6" controlId="formFile" className="mb-3">
                        <Form.Label>Proof of Payment <span>*</span></Form.Label>
                        <Form.Control
                          type="file"
                          {...register("payment", {
                            required: { message: "Proof of payment is require", value: true },
                            validate: {
                              size: (file) => {
                                return file?.[0]?.size <= 2 * 1024 * 1024 || "File size exceeds 2MB"
                              }
                            }
                          })} />
                        {errors.payment ? <p className="errMsg">{errors.payment.message}</p> : null}
                      </Form.Group>

                      <Form.Group as={Col} md="6" controlId="formFile" className="mb-3">
                        <Form.Label>Invoice</Form.Label>
                        <Form.Control
                          type="file"
                          {...register("invoice", {
                            validate: {
                              size: (file) => {
                                if (!file?.[0]) {
                                  return true;
                                }
                                return file?.[0]?.size <= 2 * 1024 * 1024 || "File size exceeds 2MB"
                              }
                            }
                          })} />
                        {errors.invoice ? <p className="errMsg">{errors.invoice.message}</p> : null}
                      </Form.Group>
                      <div className="d-flex justify-content-end">
                        <Button className="button yellow" type="submit">Submit</Button>
                      </div>
                    </Form>
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
      <Loader show={loader} />
      <CompanyNotFound
        show={companyInfo}
        onHide={() => { setCompanyInfo(false) }} />
    </>
  )
}

export default Receiverdetails